// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bt-1 {\n  border-top: 1px solid #666;\n}\n.el-badge__content {\n  pointer-events: none;\n}\n.up[x-placement^=\"bottom\"] {\n  margin-top: 5px !important;\n}\n", ""]);
// Exports
module.exports = exports;
